export default (function ($) {
    let _instance = {
        querying: false
    };

    var breakpoints = {
        0: {
            items: 1,
            margin: 15,
        },
        576: {
            items: 1,
            margin: 15,
            stagePadding: 30,
        },
        640: {
            items: 1,
            margin: 20,
            stagePadding: 30,
        },
        768: {
            items: 1,
            margin: 30,
            stagePadding: 50,
        },
        992: {
            items: 2,
            margin: 20,
            stagePadding: 50,
        },
        1200: {
            items: 2,
            margin: 30,
            stagePadding: 100,
        },
        1400: {
            items: 3,
            margin: 30,
            stagePadding: 100,
        },
        1700: {
            items: 4,
            margin: 30,
            stagePadding: 100,
        }
    };

    _instance.queryNewMonth = function ($cal) {
        if ($cal.hasClass(".ui-datepicker-prev") || $cal.hasClass(".ui-datepicker-next")) return false;

        var id = $cal.data("id");
        var $slider = $('.slider[data-id="' + id + '"]').find(".owl-carousel");

        $cal.addClass("calendar--loading");

        _instance.queryData($cal).then(() => {
            _instance.reinitializeCalender($cal);
            _instance.reinitializeSlider($slider);

            if ($slider.length > 0) {
                _instance.setPlaceholders($slider);
            }

            $cal.datepicker("refresh");
            $cal.removeClass("calendar--loading");
            _instance.querying = false;
        });
    };

    _instance.reinitializeSlider = function ($slider) {
        if ($slider.length === 0) return false;
        _instance.renderSlides($slider);
    };

    _instance.reinitializeCalender = function ($cal) {
        var d = new Date();
        if (!$cal.data("year")) $cal.data("year", d.getFullYear());
        if (!$cal.data("month")) {
            $cal.data("month", ("0" + (d.getMonth() + 1)).slice(-2));
        }

        var month = ("0" + $cal.data("month")).slice(-2)
        var currentDate = new Date($cal.data("year") + "-" + month + '-01T06:00:00Z');
        var closestDates = _instance[$cal.data("id")].dates.filter(function (d) {
            var date = new Date(d + ' 06:00:00 GMT');
            return date - currentDate > 0;
        });

        if (closestDates && closestDates.length > 0) {
            var closestDate = new Date(closestDates[0]);
            $cal.datepicker(
                'setDate',
                $.datepicker.parseDate(
                    'yy-mm-dd',
                    closestDate.getFullYear() + '-' + (closestDate.getMonth() + 1) + '-' + ("0" + closestDate.getDate()).slice(-2)
                )
            );
        } else {
            $cal.datepicker(
                'setDate',
                $.datepicker.parseDate(
                    'yy-mm-dd',
                    currentDate.getFullYear() + '-' + (currentDate.getMonth() + 1) + '-' + ("0" + currentDate.getDate()).slice(-2)
                )
            );
        }
    }


    _instance.resizeSelect = function () {
        var arrowWidth = 25;
        $("select.ui-datepicker-month").each(function () {
            var text = $(this).find("option:selected").text();
            var $test = $("<span>").html(text).css({
                "font-size": $(this).css("font-size"), // ensures same size text
                "visibility": "hidden" // prevents FOUC
            });
            $test.appendTo($(this).parent());
            var width = $test.width();
            $test.remove();
            // set select width
            $(this).css("width", (width + arrowWidth));
        });
    };

    _instance.initializeCalender = function ($cal, rerun) {
        var id = $cal.data("id");

        if (!!$cal.data('currentdate')) {
            var currentDate = new Date($cal.data('currentdate') + ' 05:00:00 GMT');
        } else {
            var currentDate = new Date();
        }

        var closestDates = _instance[id].dates.filter(function (d) {
            var date = new Date(d + ' 05:00:00 GMT');
            return date - currentDate >= 0;
        });

        if (!rerun && closestDates.length === 0) {
            if ($cal.data("month") === 12) {
                $cal.data("month", "01");
                $cal.data("year", $cal.data("year") + 1);
            } else {
                $cal.data("month", ("0" + (parseInt($cal.data("month")) + 1)).slice(-2));
            }
 
            _instance.queryData($cal).then(() => {
                _instance.initializeCalender($cal, true);
                _instance.initializeSlider($cal, true);
            });

            return false;
        }

        var date = (closestDates && closestDates.length > 0) ? new Date(closestDates[0]) : currentDate;

        var parsedDate = $.datepicker.parseDate(
            'yy-mm-dd',
            date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + ("0" + date.getDate()).slice(-2)
        );

        $cal.datepicker({
            inline: true,
            sideBySide: true,
            defaultDate: parsedDate,
            changeMonth: true,
            changeYear: true,
            yearRange: "2007:" + ((new Date().getFullYear()) + 1),
            monthNamesShort: $(window).width() > 768 ? $.datepicker.regional['en'].monthNames : $.datepicker.regional['en'].monthNamesShort,
            beforeShowDay: (d) => {
                var year = d.getFullYear(),
                    month = ("0" + (d.getMonth() + 1)).slice(-2),
                    day = ("0" + (d.getDate())).slice(-2);
                var date = month + '/' + day + '/' + year;
                return [true, $.inArray(date, _instance[id].dates) >= 0 ? "ui-state-has-lectionary" : ''];
            },
            onSelect: () => {
                var date = $cal.datepicker('getDate');
                var parsedDate = $.datepicker.formatDate("MM dd, yy", date);
                var date = $.datepicker.formatDate("mm/dd/yy", date);
                var $slider = $('.slider[data-id="' + id + '"]');
                var $slide = $slider.find(".slider__item[data-date='" + parsedDate + "']");

                if ($slide.length > 0) {

                    const links = $slide.find('.slider__commentary[data-link], a.slider__commentary');

                    if(links.length === 0) {
                        var slideIndex = $slide.closest(".owl-item").index();
                        $slider.find(".owl-carousel").trigger('to.owl.carousel', slideIndex);
                    } else {
                        if (links.length === 1) {
                            window.location = links.data('link');
                        } else if (links.length >= 2) {
                            const lectionaryDayResultTemplate = wp.template('lectionary-day-result-popup');
                            const data = _instance.data;

                            let slidesStr = '';

                            Object.keys(data).forEach((item) => {
                                if (date === $.datepicker.formatDate('mm/dd/yy', new Date(item))) {
                                    slidesStr += lectionaryDayResultTemplate({
                                        commentaries: data[item],
                                        calendar_date: new Date(item),
                                        calendar_date_formatted: $.datepicker.formatDate('MM dd, yy', new Date(item))
                                    });
                                }
                            });

                            const sliderParent = $slider.parent();

                            sliderParent.find('.lectionary-day-calendar-popup').remove();
                            sliderParent.find('.calendar__datepicker').append(slidesStr);
                        }

                    }

                    const closePopupBtn = $('.lectionary-day-calendar-popup__close');

                    closePopupBtn.on('click', function (e) {
                        closePopupBtn.parent().remove();
                    });
                } else {
                    if (!!_instance[id].links[date]) {
                        window.location = _instance[id].links[date];
                    }
                }
            },
            onChangeMonthYear: (year, month) => {
                if (!_instance.querying) {
                    if (parseInt($cal.data("month")) === month &&
                        parseInt($cal.data("year")) === year) {
                        return false;
                    }

                    $cal.data("month", month);
                    $cal.data("year", year);
                    _instance.querying = true;
                    _instance.queryNewMonth($cal);
                }
            },
        });

        $("select.ui-datepicker-month").initialize(function () {
            _instance.resizeSelect();
        });

        setTimeout(function () {
            _instance.resizeSelect();
        }, 500);

    };



    _instance.changeCalenderDay = function ($slider, $cal, event) {

        var slide_index = event.property.value

        var $slide = $slider.find(".slider__item").eq(slide_index);

        if ($slide.length === 0) return false;

        var date = new Date($slide.data('date') + ' 6:00:00 GMT');

        $cal.datepicker(
            'setDate',
            $.datepicker.parseDate(
                'yy-mm-dd',
                date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + ("0" + date.getDate()).slice(-2)
            )
        );

    }

    _instance.renderLoaderSlides = function ($slider) {

        if ($slider.length === 0) return false;

        $slider.find('.slider__item').each(function (i) {
            $slider.trigger('remove.owl.carousel', [i]).trigger('refresh.owl.carousel');
        });

        var lectionaryDayResultTemplate = wp.template('lectionary-day-loader-result');
        for (var i = 0; i < 3; i++) {
            $slider.trigger('add.owl.carousel', [lectionaryDayResultTemplate()])
        }

        $slider.owlCarousel('refresh');
    }


    _instance.renderSlides = function ($slider) {

        $slider.find('.slider__item').each(function (i) {
            $slider.trigger('remove.owl.carousel', [i]).trigger('refresh.owl.carousel');
        });

        var lectionaryDayResultTemplate = wp.template('lectionary-day-result');

        $.each(_instance.data, function (key, commentaries) {

            var commentariesData = [];
            $.each(commentaries, function (commentary_key, commentary) {
                var slider_obj = {
                    commentary: commentary,
                    calendar_date: new Date(key),
                    calendar_date_formatted: $.datepicker.formatDate("MM dd, yy", new Date(key))
                };

                if(commentaries.length > 1 && commentary_key === 0) {
                    slider_obj.another_commentary = commentaries[1];
                }

                if ($slider.hasClass("owl-carousel--single")) {
                    $slider.trigger('add.owl.carousel', [lectionaryDayResultTemplate(slider_obj)])
                } else {
                    commentariesData.push(slider_obj);
                }
            });

            if (!$slider.hasClass("owl-carousel--single")) {
                $slider.trigger('add.owl.carousel', [lectionaryDayResultTemplate(commentariesData)])
            }

        });

        $slider.owlCarousel('refresh');
    }

    _instance.initializeSlider = function ($cal) {

        var id = $cal.data("id");

        var $sliderParent = $('.slider[data-id="' + $cal.data("id") + '"]');

        if ($sliderParent.length === 0) return false;

        var $slider = $sliderParent.find('.owl-carousel');

        var options = {
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            autoplay: false,
            dots: false,
            items: 3,
            loop: false,
            lazyLoad: true,
            lazyLoadEager: 1,
            mouseDrag: true,
            autoHeight: !$slider.hasClass("owl-carousel--single"),
            touchDrag: true,
            onResized: (event) => {
                _instance[id].breakpoint = event.relatedTarget._breakpoint;
                syncPosition($slider, event);
            },
            onInitialized: (event) => {
                _instance[id].breakpoint = event.relatedTarget._breakpoint;
                syncPosition($slider, event);
            },
            onChange: (event) => {
                _instance.changeCalenderDay($slider, $cal, event);
            },
            onRefreshed: (event) => {
                syncPosition($slider, event);
            },
            onTranslate: (event) => {
                syncPosition($slider, event);
            },
            nav: false,
            responsive: breakpoints
        };

        if ($sliderParent.hasClass("slider--sidebar")) {
            options.items = 1;
            options.singleItem = true;
            options.responsive = {
                0: {
                    items: 1,
                    margin: 30,
                },
            };
        }

        $slider.owlCarousel(options);

        _instance.renderSlides($slider);
        _instance.setPlaceholders($slider);

        if (!!$cal.data('currentdate')) {
            var currentDate = new Date($cal.data('currentdate') + ' 00:00:00 GMT');
        } else {
            var currentDate = new Date();
        }

        var closestDates = _instance[id].dates.filter(function (d) {
            var date = new Date(d + ' 00:00:00 GMT');
            return date - currentDate >= 0;
        });

        var date = (closestDates && closestDates.length > 0) ? new Date(closestDates[0]) : currentDate;
        var parsedDate = $.datepicker.formatDate("MM dd, yy", date);
        var $slide = $slider.find(".slider__item[data-date='" + parsedDate + "']");
        var $owlItem = $slide.closest('.owl-item');

        if ($owlItem.length > 0) {
            var slideIndex = $owlItem.index();
            $slider.trigger('to.owl.carousel', slideIndex);
        }
    };

    _instance.queryData = function ($cal) {
        return new Promise((resolve, reject) => {
            var month = ("0" + $cal.data("month")).slice(-2);
            $.get(
                "/wp-json/v1/lectionary-calendar",
                {
                    year: $cal.data("year"),
                    month: month,
                    lectionary_id: $cal.data("lectionaryid")
                },
                (data) => {
                    _instance.data = data;
                    _instance[$cal.data("id")].dates = $.map(_instance.data, function (value, date) { return date; });
                    _instance[$cal.data("id")].links = {};
                    $.each(_instance.data, function (key, value) {
                        _instance[$cal.data("id")].links[key] = value[0].commentary_permalink;
                    });

                    resolve();
                }
            ).fail(() => {
                _instance.data = [];
                _instance[$cal.data("id")].dates = [];
                resolve();
            });
        });
    }

    /**
     * Initialize the method
     *
     * @return false
     */
    _instance.init = function () {
        $(document).ready(function () {
            _instance.$calendar = $('.calendar__datepicker');

            if (_instance.$calendar.length === 0) return false;

            _instance.$calendar.each(function (index) {
                var $cal = $(this);
                var id = $cal.data("id");
                _instance[id] = {};

                _instance.queryData($cal).then(() => {
                    var result = _instance.initializeCalender($cal);
                    if (result !== false) {
                        _instance.initializeSlider($cal);
                    }
                });
            });

            $(".js-toggle-toolbar-calendar").on("click", function () {
                var $parent = $(this).closest(".toolbar__date");
                $parent.find(".toolbar__calendar").toggle();
                _instance.resizeSelect();
            });

            $(".js-toggle-lectionary").on("click", function () {
                var isVisible = $(".js-lectionary-dropdown").is(":visible");
                $(".js-lectionary-dropdown").toggle();
                $(".js-calendar-dropdown").hide();
                $(this).removeClass("toolbar__toggle--unselected");
                if (isVisible) {
                    $(".js-toggle-calendar").removeClass("toolbar__toggle--unselected");
                } else {
                    $(".js-toggle-calendar").addClass("toolbar__toggle--unselected");
                }
            });

            $(".js-toggle-calendar").on("click", function () {
                var isVisible = $(".js-calendar-dropdown").is(":visible");
                $(".js-calendar-dropdown").toggle();
                $(".js-lectionary-dropdown").hide();
                $(this).removeClass("toolbar__toggle--unselected");
                if (isVisible) {
                    $(".js-toggle-lectionary").removeClass("toolbar__toggle--unselected");
                } else {
                    $(".js-toggle-lectionary").addClass("toolbar__toggle--unselected");
                }
                _instance.resizeSelect();
            });
        });
    };

    function syncPosition($slider, event) {
        var current = event.item.index;
        $slider.find('.owl-item .slider__item').removeClass("slider__item--zoom");
        $slider.find(".owl-item").eq(current).find('.slider__item').addClass("slider__item--zoom");
    }

    _instance.setPlaceholders = function ($slider) {
        var breakpoint = breakpoints[_instance[$slider.data("id")].breakpoint];

        var placeholderCount = $slider.find(".slider__item--placeholder").length;
        var owlItemIndexToRemove = $slider.find(".owl-item").length - 1;

        for (var j = 0; j < placeholderCount; j++) {
            $slider.trigger('remove.owl.carousel', [owlItemIndexToRemove]);
            owlItemIndexToRemove--;
        }

        // add placeholders so calendar slider works properly
        for (var i = 0; i < (breakpoint.items - 1); i++) {
            $slider.trigger('add.owl.carousel', ['<div class="slider__item slider__item--placeholder"></div>']);
        }

        $slider.trigger('refresh.owl.carousel');
    }

    return _instance;

})(jQuery)
